module.exports = __webpack_public_path__ + "img/MCPK10.png";